export const setModalBoasVindasJaMostrado = (): void => {
  sessionStorage.setItem('modalBoasVindasMostrado', 'true');
}

export const getModalBoasVindasJaMostrado = (): boolean => {
  return sessionStorage.getItem('modalBoasVindasMostrado') === 'true';
}